import { WrappedCrossChainTrade } from 'src/features/cross-chain/calculation-manager/providers/common/models/wrapped-cross-chain-trade';

export type WrappedCrossChainTradeOrNull = WrappedCrossChainTrade | null;
